'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _item = require('../../redux/modules/item');

var _filteredItems = require('../../redux/modules/filteredItems');

var _similarItems = require('../../redux/modules/similarItems');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SimilarItems = require('./SimilarItems');

var _SimilarItems2 = _interopRequireDefault(_SimilarItems);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimilarItemsContainer = (_dec = (0, _reactRedux.connect)(function (state, _ref) {
    var itemId = _ref.itemId;

    var headerMessage = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'bid_on_similar_items'
    });
    var item = (0, _item.getItem)(state, itemId);
    var similarItems = (0, _similarItems.getSimilarItems)(state, itemId);
    if (similarItems.length === 0) {
        similarItems = (0, _filteredItems.getMostPopularItemsByBids)(state, item.sellerId);
        headerMessage = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
            id: 'bid_most_popular_items'
        });
    }

    return {
        headerMessage: headerMessage,
        similarItems: similarItems
    };
}), _dec(_class = function (_Component) {
    (0, _inherits3.default)(SimilarItemsContainer, _Component);

    function SimilarItemsContainer() {
        (0, _classCallCheck3.default)(this, SimilarItemsContainer);
        return (0, _possibleConstructorReturn3.default)(this, (SimilarItemsContainer.__proto__ || (0, _getPrototypeOf2.default)(SimilarItemsContainer)).apply(this, arguments));
    }

    (0, _createClass3.default)(SimilarItemsContainer, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'itemId', 'slider', 'headerMessage', 'similarItems']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                headerMessage = _props.headerMessage,
                similarItems = _props.similarItems,
                slider = _props.slider;


            return (0, _jsx3.default)(_SimilarItems2.default, {
                className: className,
                headerMessage: headerMessage,
                similarItems: similarItems,
                slider: slider
            });
        }
    }]);
    return SimilarItemsContainer;
}(_react.Component)) || _class);
exports.default = SimilarItemsContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SimilarItems/SimilarItemsContainer.js
// module id = CRk2
// module chunks = 46